module.exports = __webpack_public_path__ + "logo.png?a11c17a9533c2adb20352c456f44e52f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 44
// module chunks = 0